module.exports = __webpack_public_path__ + "img/logo.98ad3a20.png";